import React from 'react';
import { Link } from 'react-router-dom';
import '../home/home.css';
import '../../style/global.css';
import logoFoxfiscal from '../../images/Foxfiscal.png';
import Footer from '../../components/footer/footer';

const EmConstrucao = () => {
    return (
        <div className="ns-home">
            <main className="ns-main" style={{ paddingTop: '4rem' }}>
                <section className="ns-section ns-section--dark">
                    <div className="ns-section__heading ns-section__heading--light">
                        <span className="ns-kicker">FoxFiscal</span>
                        <h2>Página em construção</h2>
                        <p>
                            O FoxFiscal está em evolução. Em breve esta página terá apresentação completa,
                            funcionalidades e materiais comerciais.
                        </p>
                    </div>

                    <div className="ns-product-card" style={{ cursor: 'default' }}>
                        <div className="ns-product-card__logo-wrap">
                            <img src={logoFoxfiscal} alt="FoxFiscal" className="ns-product-card__logo" />
                        </div>
                        <h3>FoxFiscal</h3>
                        <p>
                            Solução de apoio fiscal e operacional voltada para conferências, validações tributárias
                            e rotinas críticas ligadas a documentos eletrônicos.
                        </p>
                        <div className="ns-hero__actions">
                            <Link to="/" className="ns-btn ns-btn--primary">
                                Voltar para a home
                            </Link>
                            <Link to="/provisionamento" className="ns-btn ns-btn--secondary">
                                Solicitar atendimento
                            </Link>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default EmConstrucao;
